<template>
  <div
    v-if="stepsLength"
    class="md-example-child md-example-child-steps md-example-child-steps-8 resultSuccessDetail"
  >
    <md-steps
      direction="vertical"
      :steps="steps"
      :current="current"
      :class="[stepsLength === 2 ? 'failIcon' : 'successIcon']"
    >
      <div
        slot="content"
        slot-scope="{ index, step }"
        class="custom-content"
      >
        <template v-if="index === 1">
          <div class="name active" v-text="step.name" />
          <div class="desc" v-html="step.text" />
          <div class="desc" v-html="step.time" />
        </template>
        <template v-else>
          <div class="name" v-text="step.name" />
          <div class="desc" v-html="step.time" />
        </template>
      </div>
    </md-steps>
    <div class="resultInfo">
      <slot />
    </div>
    <div v-if="showButton" class="footer_btn">
      <md-button
        v-if="stepsLength === 2"
        type="primary"
        @click="$router.push({name: name})"
      >
        {{ $t('try_again') }}
      </md-button>
      <md-button type="default" :class="['tryBtn', stepsLength === 2 ? 'footer_btn_second' : '']" @click="$router.push('/home')">{{ $t('back_to_homepage') }}</md-button>
    </div>
  </div>
</template>

<script>
import { Steps, Amount, Icon, Button } from 'mand-mobile'
export default {
  name: 'ResultBankSteps',

  components: {
    [Steps.name]: Steps,
    [Amount.name]: Amount,
    [Icon.name]: Icon,
    [Button.name]: Button
  },

  props: {
    isHistory: {
      type: [String, Boolean],
      default: false
    },

    steps: {
      type: Array,
      required: true
    },

    current: {
      type: [String, Number],
      required: true
    },

    name: {
      type: String,
      default: ''
    }
  },

  computed: {
    showButton () {
      return !this.isHistory
    },
    stepsLength () {
      return this.steps.length
    }
  }
}

</script>

<style lang="scss" scoped>
.resultSuccessDetail {
  background: #fff;
  padding: 34px 40px 34px 40px;
  box-sizing: border-box;

  .md-steps {
    padding: 0 16px;
  }

  .footer_btn {
    width: 100%;
    margin-top: 202px;
    margin-bottom: 74px;

    .footer_btn_second {
      margin-top: 64px;
    }

    .md-button.default::after {
      border: none;
      border-radius: 24px;
    }

    .tryBtn {
      border: 1px solid #333;
      border-radius: 24px;
    }
  }
}

.md-example-child-steps-8 {
  .custom-content {
    .name {
      font-size: 28px;
      color: #858b9c;
      font-weight: 700;

      &.active {
        font-size: 28px;
        color: #41485d;
      }
    }

    .desc {
      line-height: 40px !important;

      span {
        color: #ff8325;
      }
    }
  }
}
/* stylelint-disable declaration-block-no-duplicate-properties, no-duplicate-selectors */
::v-deep .md-steps .bar.vertical-bar .bar-inner {
  opacity: 0;
}

::v-deep .md-steps .bar.vertical-bar {
  width: 0;
}

::v-deep .md-steps .bar.vertical-bar {
  border: 1px dashed #10aeff;
}

.failIcon ::v-deep .md-icon-success::before {
  content: '\E60E';
  color: #fa5151;
}

.successIcon ::v-deep .md-icon-success::before {
  content: '\e908';
  color: #07c160;
}
/* stylelint-enable */
</style>
